module.exports = __webpack_public_path__ + "7115aafefcabc52ae1f6540f89da72a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/deleteNoteImg.png
// module id = 76
// module chunks = 0